import React from 'react';
import DataTable from 'react-data-table-component';
import language from '../../config/es';

// Clase css para el estado del detalle de pago (anulado o no)
export const getDetailStatusClassName = (status) => {
  if (status === null) {
    return '';
  }
  return status.name.toLowerCase().includes('anulado')
    ? 'text-uppercase  text-danger'
    : 'text-primary text-uppercase ';
};

const valueOrEmpty = (value) =>
  value === null || value === 'NULL' ? '' : value;

// Columnas de la tabla de detalles (fuera del componente para no redefinirlas en cada render)
const buildColumns = (textSizeClass, amountWidth, formatAmount) => [
  {
    name: language.messages.monitor.lblBill,
    sortable: false,
    wrap: true,
    width: '250px',
    cell: (row) => (
      <span>
        <div className={`text-uppercase ${textSizeClass}`}>
          {row.documentNumber}
        </div>
        <div className={`badge bg-primary text-uppercase ${textSizeClass}`}>
          {row.typePaymentCode.name}
        </div>
      </span>
    ),
  },
  {
    name: language.messages.monitor.colUnitPrice,
    sortable: false,
    wrap: true,
    width: amountWidth,
    cell: (row) => (
      <div className=" text-end">{formatAmount(row.operationAmount)}</div>
    ),
  },
  {
    name: language.messages.monitor.lblCoin,
    sortable: false,
    wrap: true,
    width: '150px',
    cell: (row) => (
      <div className=" small-font text-uppercase">
        {row.typeCoinCode.name}({row.typeCoinCode.code})
      </div>
    ),
  },
  {
    name: language.messages.monitor.check,
    sortable: false,
    wrap: true,
    width: '100px',
    cell: (row) => (
      <span>
        <div>{valueOrEmpty(row.checkNumber)}</div>
        <div className="small-font text-uppercase text-muted">
          {valueOrEmpty(row.bankCheck)}
        </div>
      </span>
    ),
  },
  {
    name: language.messages.monitor.clState,
    sortable: false,
    wrap: true,
    width: '150px',
    cell: (row) => (
      <div className={getDetailStatusClassName(row.status)}>
        {row.status.name === null ? '' : row.status.name}
      </div>
    ),
  },
];

// Tabla de detalles de pago que se muestra al expandir una fila
const PaymentDetailTable = ({
  data,
  textSizeClass,
  amountWidth,
  formatAmount,
}) => {
  const columns = buildColumns(textSizeClass, amountWidth, formatAmount);
  return (
    <span>
      <DataTable
        title={language.messages.monitor.title + ': ' + data.trace}
        data={data.paymentDetails}
        columns={columns}
      />
      <hr />
    </span>
  );
};

export default PaymentDetailTable;
